import classNames from "classnames";
import styles from './index.module.scss';
import BaseInfo from "./baseInfo";
import ShareInfo from "./shareInfo";
import { Space } from "antd";
const Personal = () => {
	return <Space className={classNames('container', styles.personalBox)} align="top">
		<BaseInfo />
		<ShareInfo />
	</Space>
}
export default Personal;